import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Chat from './Chat';

const Layout = ({ children }) => {
  return (
    <div>
      <Header />
      <Chat />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
